






































































































import userService from './_services/user.service';
import {Component, Vue} from 'vue-property-decorator';
import {User} from '@/models/User';

@Component
export default class App extends Vue {
    private title: string = 'AMZ-Custom';
    private username: string = '';
    private password: string = '';
    private submitted: boolean = false;
    private loading: boolean = false;
    private error: string = '';
    private currentUser: User|null = null;
    private drawer: boolean = false;
    public created() {
        userService.currentUser.subscribe((x) => {
            return this.currentUser = x;
        });
    }
    public get canLogin() {
        const {username, password} = this;
        return (username && password);
    }
    public async logout(): Promise<void> {
        this.loading = true;
        await userService.logout();
        this.$router.push({ path: '/' }).catch(() => {
            // Ignore
        });
        this.loading = false;
        this.drawer = false;
    }
    public async login(): Promise<void> {
        this.submitted = true;
        const {username, password} = this;
        if (!this.canLogin) {
            return;
        }
        this.loading = true;
        try {
            this.error = '';
            await userService.login(username, password);
            this.$router.push({ path: '/export' }).catch(() => {
                // Ignore
            });
        } catch (error) {
            this.error = error.response.data.message;
        }
        this.loading = false;
        this.username = '';
        this.password = '';
    }
}
